var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar-container"},[_c('div',{staticClass:"progress-bar-inner"},[_c('div',{staticClass:"progress-bar-juice",style:('width:'+_vm.value+'%')})])])}
var staticRenderFns = []

export { render, staticRenderFns }